import React from 'react';
import InstallmentsStepOneCall from './installments/InstallmentStepOneCall';
import InstallmentsStepSecondCall from './installments/InstallmentsStepSecondCall';
import ENABLE from '../../../../constants/enable';

const InstallmentsStep = (context) => {
    return ENABLE.enableInstallmentsSecondCall
        ? <InstallmentsStepSecondCall {...context} />
        : <InstallmentsStepOneCall {...context} />;
};

export default InstallmentsStep;
